export default __webpack_public_path__ + "static/media/search.b6d1ba9d.svg";